import { Link } from "react-router-dom";

function CtaArea() {
  return (
    <section style={{ position: "relative" }} className="cta-area cta-bg">
      <div
        style={{
          backgroundColor: "black",
          opacity: 0.5,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
      />
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-xl-5 col-lg-6">
            <div
              style={{ zIndex: 1, position: "relative" }}
              className="cta-img"
            >
              <img src="assets/img/icon/whats-number-technology.webp" alt="" />
            </div>
          </div>
          <div style={{ zIndex: 2, position: "relative" }} className="col-lg-6">
            <div className="cta-content">
              <div className="cta-icon mb-15">
                <img src="assets/img/icon/cta_icon.png" alt="" />
              </div>
              <div className="section-title title-style-three white-title mb-50">
                <h2>
                  What’s<span> Number?</span>
                </h2>
                <p>Handled 2-3 Million sessions every month</p>
              </div>
              <div className="cta-btn">
                <Link to="/contact" className="btn btn-style-two">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaArea;
